export type AosProps = {
  'data-aos'?: string;
  'data-aos-delay'?: string;
  'data-aos-duration'?: string;
  'data-aos-offset'?: string;
  'data-aos-easing'?: string;
  'data-aos-once'?: string;
};

// ==============================
//  DEFAULT CONFIG
// ==============================

export const defaultAos: AosProps = {
  'data-aos-delay': '80',
  'data-aos-duration': '1000',
  'data-aos-offset': '80',
  'data-aos-easing': 'ease-out-cubic',
  'data-aos-once': 'true',
};

// ==============================
//  FADE ANIMATIONS
// ==============================

export const fadeUpAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'fade-up',
};

export const fadeDownAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'fade-down',
};

export const fadeLeftAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'fade-left',
};

export const fadeRightAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'fade-right',
};

// ==============================
//  ZOOM ANIMATIONS
// ==============================

export const zoomInAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'zoom-in',
};

export const zoomOutAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'zoom-out',
};

export const zoomInUpAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'zoom-in-up',
};

export const zoomInDownAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'zoom-in-down',
};

// ==============================
//  SLIDE ANIMATIONS
// ==============================

export const slideUpAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'slide-up',
};

export const slideDownAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'slide-down',
};

export const slideLeftAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'slide-left',
};

export const slideRightAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'slide-right',
};

// ==============================
//  FLIP ANIMATIONS
// ==============================
export const flipLeftAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'flip-left',
};
export const flipRightAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'flip-right',
};
export const flipUpAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'flip-up',
};

export const flipDownAosProps: AosProps = {
  ...defaultAos,
  'data-aos': 'flip-down',
};

// ==============================
//  CUSTOM HELPERS
// ==============================

//  Dynamic delay (stagger animations)
export const getAosDelay = (delay: number): AosProps => ({
  'data-aos-delay': String(delay),
});

//  Dynamic duration
export const getAosDuration = (duration: number): AosProps => ({
  'data-aos-duration': String(duration),
});

//  Custom offset
export const getAosOffset = (offset: number): AosProps => ({
  'data-aos-offset': String(offset),
});

//  Custom easing
export const getAosEasing = (easing: string): AosProps => ({
  'data-aos-easing': easing,
});

// Merge multiple configs
export const mergeAos = (...props: AosProps[]): AosProps =>
  Object.assign({}, ...props);
